import { Box, CircularProgress, createStyles, makeStyles } from "@material-ui/core";
import { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const useStyles = makeStyles(() =>
    createStyles({
        internalShop: {
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            position: "relative",
        },
        loaderContainer: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        },
    })
);


interface Props {
    handleBack: (updatedNumber: number) => void;
    handleNext: (updatedNumber: number) => void;
}

export default function AddressInput({ handleBack, handleNext }: Props) {
    const classes = useStyles();
    const [isBack, setIsBack] = useState(false);

    // Use useRef for logic variables to avoid closure staleness 
    const updatedNumberRef = useRef(4);

    useEffect(() => {
        const listener = (event: MessageEvent) => {
            // Navigation Logic
            if (event.data === "back") {
                updatedNumberRef.current -= (updatedNumberRef.current === 3 ? 0 : 1);
                if (updatedNumberRef.current === 3) {
                    setIsBack(true);
                }
                handleBack(updatedNumberRef.current);
            } else if (event.data === "next") {
                updatedNumberRef.current += (updatedNumberRef.current === 6 ? 0 : 1);
                handleNext(updatedNumberRef.current);
            } else if (event.data === "shop") {
                setIsBack(true);
                handleBack(3);
            }
        };

        window.addEventListener("message", listener);
        return () => window.removeEventListener("message", listener);
    }, [handleBack, handleNext]);

    return (
        <Box className={classes.internalShop}>
            {isBack ? (
                <Box className={classes.loaderContainer}>
                    <CircularProgress size={60} />
                </Box>
            ) : (
                <iframe
                    src="/checkout"
                    style={{ width: "100%", height: "100vh", border: "none" }}
                    title="checkout"
                />
            )}
        </Box>
    );
}
